import { useTheme } from "@mui/material";
import React from "react";

import { Box } from "@/Components/v2/atoms/Box";
import { Grid } from "@/Components/v2/atoms/Grid";
import { Typography } from "@/Components/v2/atoms/Typography";

type ScenarioField = {
  label: string;
  value: string;
};

type ScenarioDetailsProps = {
  scenarioFields: ScenarioField[];
};

export const ScenarioDetails: React.FC<ScenarioDetailsProps> = ({ scenarioFields }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: 3,
        borderRadius: 2,
        backgroundColor: theme.palette.mode === "light" ? "#F6F9FD" : "#2B3033",
      }}
    >
      <Grid container spacing={1.5}>
        {scenarioFields.map((item, index) => (
          <React.Fragment key={index}>
            <Grid item xs={5}>
              <Typography variant="body2" fontWeight={600}>
                {item.label}
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography variant="body2" color="text.secondary">
                {item.value}
              </Typography>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  );
};
